export default {"src":"/_next/static/media/ico-complete-ring.b68ef6cb.svg","height":33,"width":33};